
import { ResponsiveContainer, BarChart, Bar, CartesianGrid, XAxis, YAxis, Tooltip, Legend } from 'recharts';
import { format } from "date-fns";
import { fr } from "date-fns/locale";

interface TransactionCountBarChartProps {
  transactions: any[];
}

export const TransactionCountBarChart = ({ transactions }: TransactionCountBarChartProps) => {
  const transactionsByDate = transactions.reduce((acc: any, transaction) => {
    const date = format(new Date(transaction.created_at), 'P', { locale: fr });
    if (!acc[date]) {
      acc[date] = {
        date,
        transactions: 0,
      };
    }
    acc[date].transactions += 1;
    return acc;
  }, {});

  const barChartData = Object.values(transactionsByDate);

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={barChartData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar
          dataKey="transactions"
          fill="#3b82f6"
          name="Nombre de transactions"
          radius={[4, 4, 0, 0]}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};
